import { useMemo } from 'react';

const FIELD_STYLES = {
    default: 'bg-white placeholder-gray-600 appearance-none border rounded-lg outline-none focus:outline-none transition-colors',
    text: 'w-full p-3 bg-no-repeat bg-input-position',
    textInvalid: 'bg-cross bg-input-size-large pr-12',
    dark: 'border-gray-300 secondary:border-indigo-200 focus:border-lilac-500 focus:secondary:border-lilac-500',
    light: 'border-white focus:border-black',
    invalid: '!border-red',
    disabled: 'cursor-not-allowed bg-gray-100',
};
const useFieldStyles = ({ disabled, focused = false, highlight = 'primary', invalid, theme = 'dark', type = 'default', }) => {
    const styles = useMemo(() => {
        const highlightVariant = highlight === 'secondary' ? 'secondary-colors' : '';
        const isCheck = type === 'radio' || type === 'checkbox';
        const isRange = type === 'range';
        const isSelect = type === 'select';
        const isText = !isCheck && !isRange;
        const currentStyles = [FIELD_STYLES.default, highlightVariant];
        if (theme === 'light') {
            currentStyles.push(FIELD_STYLES.light);
            if (focused && isSelect) {
                currentStyles.push('!border-black');
            }
        }
        if (theme === 'dark') {
            currentStyles.push(FIELD_STYLES.dark);
            if (focused && isSelect) {
                currentStyles.push('!border-green secondary:!border-indigo-500');
            }
        }
        if (isText) {
            currentStyles.push(FIELD_STYLES.text);
        }
        if (invalid) {
            currentStyles.push(FIELD_STYLES.invalid);
            if (isText) {
                currentStyles.push(FIELD_STYLES.textInvalid);
            }
        }
        if (disabled) {
            currentStyles.push(FIELD_STYLES.disabled);
        }
        return currentStyles.join(' ');
    }, [disabled, focused, highlight, invalid, theme, type]);
    return styles;
};

export { FIELD_STYLES, useFieldStyles };
//# sourceMappingURL=useFieldStyles.js.map
